import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class QuotePolicyListDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.QuotePolicySummary, Model.Bookings.Logic.ViewModels.QuotePolicySummary, QuotePolicySummary> {
	protected map(entity: Model.Bookings.Logic.ViewModels.QuotePolicySummary): QuotePolicySummary {
		return new QuotePolicySummaryModel(entity);
	}

	static make(ctx?: any): QuotePolicyListDataService {
		return new QuotePolicyListDataService(ctx, ctx => ctx.QuotePolicySummaries);
	}
}

export class QuotePolicySummaryModel extends EntityModel<Model.Bookings.Logic.ViewModels.QuotePolicySummary, QuotePolicySummary> implements QuotePolicySummary {
	@property<QuotePolicySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<QuotePolicySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<QuotePolicySummaryModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<QuotePolicySummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

	@property<QuotePolicySummaryModel>(o => o.entity.productId, (o, value) => o.entity.productId = value)
	public productId: number;

	@property<QuotePolicySummaryModel>(o => o.entity.productDisplayName, (o, value) => o.entity.productDisplayName = value)
	public productDisplayName: string;

	@property<QuotePolicySummaryModel>(o => o.entity.hasRules, (o, value) => o.entity.hasRules = value)
	public hasRules: boolean;
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-policies/list/quote-policy-list.data.ts